import { useEffect, useState } from 'react';
import { InboundInfo } from '../fetch/fetchInbound';
import { fetchInboundForPickups } from '../fetch/fetchInboundForPickups';

export function useGetInboundInfoForPickups(): {
  inboundInfoList: InboundInfo[];
  isLoading: boolean;
} {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [inboundInfoList, setInboundInfoList] = useState<InboundInfo[]>(null);

  useEffect(() => {
    const fetchInboundInfoListMethod = async () => {
      const InboundInfoListResult = await fetchInboundForPickups();

      setInboundInfoList(InboundInfoListResult);
      setIsLoading(false);
    };

    fetchInboundInfoListMethod();
  }, [setIsLoading]);

  return { inboundInfoList, isLoading };
}
